$offset: 187;
$duration: 1.4s;

.spinner {
  animation: rotator $duration linear infinite;
  margin-right: 8px;
}

@keyframes rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}

.path {
  stroke-dasharray: $offset;
  stroke-dashoffset: 0;
  transform-origin: center;
  stroke: white;
  animation: dash $duration ease-in-out infinite;
}

.strokeBlack {
  stroke: black !important;
}

@keyframes dash {
  0% {
    stroke-dashoffset: $offset;
  }
  50% {
    stroke-dashoffset: calc($offset/4);
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: $offset;
    transform: rotate(450deg);
  }
}

.spinnerDiv {
  display: flex;
  justify-content: center;
  align-items: center;
}
